/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForTclItsmCmdbConfiguration extends models.GovernanceConfigurationBaseForForTclItsm {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForTclItsmCmdbConfiguration");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForTclItsmCmdbConfiguration.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForTclItsmCmdbConfiguration>): GovernanceConfigurationForTclItsmCmdbConfiguration {
        let obj = Object.assign(new GovernanceConfigurationForTclItsmCmdbConfiguration(), model);
        GovernanceConfigurationForTclItsmCmdbConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForTclItsmCmdbConfiguration>): GovernanceConfigurationForTclItsmCmdbConfiguration {
        if (!model) return null;
        return GovernanceConfigurationForTclItsmCmdbConfiguration.newInstance(<GovernanceConfigurationForTclItsmCmdbConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForTclItsmCmdbConfiguration) {
        if (!obj) return;

        models.GovernanceConfigurationForTclItsmCmdbConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForTclItsmCmdbConfiguration): boolean {
        if (models.GovernanceConfigurationBaseForForTclItsm.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForTclItsmCmdbConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.cmdb_configuration_mapping) {
            for (let val of this.cmdb_configuration_mapping) {
                models.TclItsmCorestackResourceMapping.fixupPrototype(val);
            }
        }
    }

    /**
     * Attribute mapping for  TCL ITSM CMDB
     */
    cmdb_configuration_mapping: Array<models.TclItsmCorestackResourceMapping>;

}
